import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {mergeRefs} from '../../../lib/refHelper';

import './DeckInsert.scss';
import withIntl from '../../../lib/withIntl';

const PlaceHolder = withIntl(({number, deepWellOnly, intl}) => (
  <div className="deck-insert-placeholder">
    <div className="deck-insert-placeholder-label">{number}</div>
    {deepWellOnly && (
      <div className="deck-insert-placeholder-label-caption">
        {intl.formatMessage({id: 'protocolEditor.deckInsert.deepWellOnly'})}
      </div>
    )}
  </div>
));

PlaceHolder.propTypes = {
  number: PropTypes.number.isRequired,
  deepWellOnly: PropTypes.bool.isRequired,
  intl: PropTypes.any.isRequired,
};

const DeckInsert = React.forwardRef((props, ref) => {
  const {
    number,
    children,
    drop = () => {},
    isOver,
    canDrop,
    allowedToSwitchLabware,
    enableHoverInteraction,
    isSelected,
    onHoverDeck,
    className,
    deepWellOnly,
    selectionMode,
  } = props;
  const [isHover, setIsHover] = useState(false);

  const generateClassName = () => {
    let clName = 'deck-insert-content';

    if (!isOver) {
      return clName;
    }

    if (!canDrop) {
      clName += ' drop-not-allow';
    } else {
      clName += allowedToSwitchLabware ? ' drop-allow' : ' drop-not-allow';
    }

    return clName;
  };

  const generateWrapperClassName = () => {
    let baseName = 'deck-insert-wrapper';
    let insertStatus = '';

    if (selectionMode) {
      baseName = `${baseName}-selection`;

      if (isSelected) insertStatus = 'deck-insert-selected';
      else if (isHover) insertStatus = 'deck-insert-hovered';
    }

    return `${baseName} ${insertStatus} ${className}`;

    // if (isSelected) {
    //   const clName = `${baseName} .deck-insert-selected ${className}`;
    //   if (isHover) {
    //     return `${clName} hovered`;
    //   }

    //   return clName;
    // }

    // if (isHover) {
    //   return `${baseName} deck-insert-hovered ${className}`;
    // }

    // return `${baseName} ${className}`;
  };

  return (
    <div className={generateWrapperClassName()}>
      <div
        className={`deck-insert-container ${children ? '' : 'empty'}`}
        onMouseEnter={() => {
          if (enableHoverInteraction && !isHover) {
            setIsHover(true);
            onHoverDeck(number, true);
          }
        }}
        onMouseLeave={() => {
          if (isHover) {
            setIsHover(false);
            onHoverDeck(number, false);
          }
        }}
      >
        <div ref={mergeRefs(ref, drop)} className={generateClassName()}>
          {children || <PlaceHolder number={number} deepWellOnly={deepWellOnly} />}
        </div>
      </div>
    </div>
  );
});

DeckInsert.propTypes = {
  number: PropTypes.number.isRequired,
  children: PropTypes.any,
  drop: PropTypes.any,
  isOver: PropTypes.bool,
  canDrop: PropTypes.bool,
  allowedToSwitchLabware: PropTypes.bool,
  enableHoverInteraction: PropTypes.bool,
  isSelected: PropTypes.bool,
  onHoverDeck: PropTypes.func,
  className: PropTypes.className,
  deepWellOnly: PropTypes.bool,
  selectionMode: PropTypes.bool,
};

DeckInsert.defaultProps = {
  children: null,
  drop: () => {},
  isOver: false,
  canDrop: false,
  allowedToSwitchLabware: true,
  enableHoverInteraction: false,
  isSelected: false,
  onHoverDeck: () => {},
  className: '',
  deepWellOnly: false,
  selectionMode: false,
};

export default DeckInsert;
